import React from "react";
import { Grid, Typography } from "@mui/material";
import WorkOrderForm from "../components/Common/WorkOrderForm";
import theme from "../utils/theme";
import AppButton from "../components/Common/AppButton";
import useCreateRFI from "../hooks/useCreateRFI";

const styles = {
  wrapper: { bgcolor: theme.palette.background.default },
  buttonContainer: { display: "flex", justifyContent: "flex-end" },
  title: {
    p: 2,
    bgcolor: theme.palette.background.dark,
    color: theme.palette.text.light,
    borderRadius: 2,
  },
};

export default function CreateRFI() {
  const {
    fields,
    handleFieldChange,
    fetchWorkOrderDetails,
    error,
    handleCreateRFI,
  } = useCreateRFI();

  return (
    <Grid container spacing={2} sx={styles.wrapper}>
      <Grid item size={{ xs: 12 }} sx={styles.title}>
        <Typography variant="h4">Create RFI</Typography>
      </Grid>

      <Grid item size={{ xs: 12 }}>
        <WorkOrderForm
          fields={fields}
          handleFieldChange={handleFieldChange}
          handleSubmit={fetchWorkOrderDetails}
          editable={true}
          collapsibleOpen={true}
          setCollapsibleOpen={() => {}}
          error={error}
        />
      </Grid>
      <Grid item size={{ xs: 12 }} sx={styles.buttonContainer}>
        <AppButton
          buttonType="primary"
          label="Create RFI"
          onClick={handleCreateRFI}
        />
      </Grid>
    </Grid>
  );
}
